

























































































import Vue from 'vue';

import HomeHeader 	from '@/components/landing/header.vue';
import HeroBanner	from '@/components/landing/hero.vue';
import Spotlight	from '@/components/landing/spotlight.vue';
import SpotlightLg	from '@/components/landing/spotlight-large.vue';
import Feature		from '@/components/landing/feature.vue';
import Copywrite	from '@/components/footer-copyright.vue';

export default Vue.extend({
	components: {
		HomeHeader,
		HeroBanner,
		Spotlight,
		SpotlightLg,
		Feature,
		Copywrite
	},
})
